

/* TV Maze APIs */
export const API_BASE_URL = "https://api.tvmaze.com/";
export const SEARCH_ENDPOINT = "search/shows?q=";
export const SHOWS_ENDPOINT = "shows";
export const SEASONS_ENPOINT = "seasons";
export const EPISODES_ENDPOINT = "episodes";
export const GET_URL_EPISODES = `https://api.tvmaze.com/seasons`;


/* Social Media Links */
export const GITHUB_LINK = "https://github.com/HarshithaSolai/abn-amro-assignment";



export const SHIMMER_SHOW_CARDS_COUNT = 20;


export const DEBOUNCE_DELAY = 200;


